<template>
    <div class="mt-8" v-if="totalItems > 0">
        <div class="font-semibold mb-2">{{ $t("strategies") }}</div>
        <div v-if="totalItems > 0">
            <div class="lg:hidden grid md:grid-cols-2 gap-3">
                <k-panel v-for="item in items" :key="item.uuid" class="bg-white px-2 py-2 border">
                    <div class="flex flex-row mb-4 pb-2 border-b items-center">
                        <div class="flex">
                            <div class="font-semibold text-sm">{{item.name}}</div>
                        </div>
                    </div>
                    <k-panel-row>
                        <div slot="left">{{ $t("status") }}</div>
                        <div slot="right">{{item.status}}</div>
                    </k-panel-row>
                    <k-panel-row>
                        <div slot="left">{{ $t("interestRate") }}</div>
                        <div slot="right">{{item.params.minInterestRate}}% - {{item.params.maxInterestRate}}%</div>
                    </k-panel-row>
                    <k-panel-row>
                        <div slot="left">{{ $t("currency") }}</div>
                        <div slot="right">{{item.currencyCode}}</div>
                    </k-panel-row>
                    <k-panel-row>
                        <div slot="left">{{ $t("remainingTerm") }}</div>
                        <div slot="right">{{item.params.minRemainingLoanTerm}} -
                            {{item.params.maxRemainingLoanTerm}}
                        </div>
                    </k-panel-row>
                    <k-panel-row>
                        <div slot="left">{{ $t("portfolioSize") }}</div>
                        <div slot="right">{{item.params.portfolioSize | currencyFormat(item.currencySymbol)}}</div>
                    </k-panel-row>
                    <k-panel-row>
                        <div slot="left">{{ $t("outstandingPrincipal") }}</div>
                        <div slot="right">{{item.outstandingPrincipal | currencyFormat(item.currencySymbol)}}</div>
                    </k-panel-row>
                    <k-panel-row>
                        <div slot="left">
                            <a-button type="primary" ghost class="mr-2"
                                      @click.native.prevent="editStrategy(item.uuid)">
                                {{ $t("view") }}
                            </a-button>
                            <a-button type="primary" ghost class="mr-2"
                                      @click.native.prevent="editStrategy(item.uuid)">
                                {{ $t("edit") }}
                            </a-button>
                            <a-button type="primary" ghost class="mr-2"
                                      @click.native.prevent="pauseStrategy(item.uuid)"
                                      v-if="item.status === 'ACTIVE'">
                                {{ $t("pause") }}
                            </a-button>
                            <a-button type="primary" ghost class="mr-2"
                                      @click.native.prevent="activateStrategy(item.uuid)"
                                      v-if="item.status === 'PAUSED'">
                                {{ $t("activate") }}
                            </a-button>
                        </div>
                        <div slot="right">
                            <a-popconfirm
                                title="Delete autoinvestment strategy?"
                                ok-text="Yes"
                                cancel-text="No"
                                @confirm="disableStrategy(item.uuid)"
                            >
                                <a-button type="danger" ghost>
                                    {{ $t("delete") }}
                                </a-button>
                            </a-popconfirm>
                        </div>
                    </k-panel-row>
                    <a-collapse :bordered="false" expand-icon-position="right">
                        <a-collapse-panel header="Details" class="p-0 no-bottom-border">
                            <k-panel-row v-for="(investment, index) in item.investments" :key="index">
                                <div slot="left">{{investment.company}} ({{investment.interestRate}}%)</div>
                                <div slot="right">
                                    {{investment.outstandingPrincipal | currencyFormat(item.currencySymbol)}}
                                </div>
                            </k-panel-row>
                        </a-collapse-panel>
                    </a-collapse>
                </k-panel>
            </div>
        </div>
        <div class="hidden lg:block mt-8">
            <k-table :data-set="dataSet" :pagination-visible="false" row-key="id">
                <a-table-column title="Name" key="name" data-index="name" :ellipsis="true"/>
                <a-table-column title="Status" data-index="status" :ellipsis="true"/>
                <a-table-column title="Parameters" data-index="parameters" :ellipsis="true">
                    <template slot-scope="text, item">
                        <div class="grid grid-cols-2 text-sm">
                            <div class="text-gray-700">{{ $t("currency") }}</div>
                            <div>{{item.currencyCode}}</div>
                            <div class="text-gray-700">{{ $t("interestRate") }}</div>
                            <div>{{item.params.minInterestRate}}% - {{item.params.maxInterestRate}}%</div>
                            <div class="text-gray-700">{{ $t("remainingTerm") }}</div>
                            <div>{{item.params.minRemainingLoanTerm}} - {{item.params.maxRemainingLoanTerm}}</div>
                        </div>
                    </template>
                </a-table-column>
                <a-table-column title="Portfolio size" key="params.portfolioSize" data-index="params.portfolioSize"
                                :ellipsis="true" align="right">
                    <template slot-scope="text, item">{{text | currencyFormat(item.currencySymbol)}}</template>
                </a-table-column>
                <a-table-column title="Outstanding amount" key="outstandingAmount" data-index="outstandingPrincipal"
                                :ellipsis="true" align="right">
                    <template slot-scope="text, item">{{text | currencyFormat(item.currencySymbol)}}</template>
                </a-table-column>
                <a-table-column title="Actions">
                    <template slot-scope="text, item">
                        <a-button type="primary" ghost class="mr-2" @click.native.prevent="editStrategy(item.uuid)">
                            {{ $t("view") }}
                        </a-button>
                        <a-button type="primary" ghost class="mr-2" @click.native.prevent="editStrategy(item.uuid)">
                            {{ $t("edit") }}
                        </a-button>
                        <a-button type="primary" ghost class="mr-2" @click.native.prevent="pauseStrategy(item.uuid)"
                                  v-if="item.status === 'ACTIVE'">
                            {{ $t("pause") }}
                        </a-button>
                        <a-button type="primary" ghost class="mr-2"
                                  @click.native.prevent="activateStrategy(item.uuid)"
                                  v-if="item.status === 'PAUSED'">
                            {{ $t("activate") }}
                        </a-button>
                        <a-popconfirm
                            title="Delete autoinvestment strategy?"
                            ok-text="Yes"
                            cancel-text="No"
                            @confirm="disableStrategy(item.uuid)"
                        >
                            <a-button type="danger" ghost>
                                {{ $t("delete") }}
                            </a-button>
                        </a-popconfirm>
                    </template>
                </a-table-column>
                <a-table
                    slot="expandedRowRender"
                    slot-scope="item"
                    :data-source="item.investments"
                    :pagination="false"
                    row-key="company"
                >
                    <a-table-column title="Company" key="company" data-index="company" :ellipsis="true"/>
                    <a-table-column title="Interest rate" data-index="interestRate" :ellipsis="true">
                        <template slot-scope="text">{{text | numeralFormat('0.00')}}%</template>
                    </a-table-column>
                    <a-table-column title="Maturity date" data-index="maturityDate" :ellipsis="true"/>
                    <a-table-column title="Outstanding principal" data-index="outstandingPrincipal"
                                    :ellipsis="true">
                        <template slot-scope="text">{{text | numeralFormat('$0,0.00')}}</template>
                    </a-table-column>

                </a-table>
            </k-table>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        props: {
            totalItems: {
                type: Number,
                required: true
            },
            items: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
            };
        },
        computed: {
            dataSet() {
                return {
                    items: this.items,
                    totalItems: this.totalItems
                }
            }
        },
        methods: {
            editStrategy(uuid) {
                this.$emit('edit-strategy', uuid);
            },
            disableStrategy(uuid) {
                this.$emit('disable-strategy', uuid);
            },
            pauseStrategy(uuid) {
                this.$emit('pause-strategy', uuid);
            },
            activateStrategy(uuid) {
                this.$emit('activate-strategy', uuid);
            }
        }
    };
</script>

<style scoped>
    .no-bottom-border {
        border-bottom: 0;
    }
</style>


